class NotificationType {
	constructor() {
		this.eventTypeID = null;
		this.actionID = null;
		this.name = null;
	}
}

//Notiification Type Definitions. event ID's and action ID's derived from notification events returned from
//api/ApplicationManagement/GetAppNotifications

///Add/modify submission notification
const AddModifySubmission = new NotificationType();
AddModifySubmission.actionID = 245;
AddModifySubmission.eventTypeID = 50;
AddModifySubmission.name = 'Add/Modify Submission Notification';

//Request Approval
const RequestApproval = new NotificationType();
RequestApproval.actionID = 245;
RequestApproval.eventTypeID = 64;
RequestApproval.name = 'Approval Notification (Add/Modify access)';

//Term/Revoke request notification
const TermRevokeRequest = new NotificationType();
TermRevokeRequest.actionID = 295;
TermRevokeRequest.eventTypeID = 50;
TermRevokeRequest.name = 'Term/Revoke Access Notification';

//Request Completion Notification
const RequestCompletion = new NotificationType();
RequestCompletion.actionID = 19;
RequestCompletion.eventTypeID = 52;
RequestCompletion.name = 'Request Completion Notification';

////Multiple Work Queue notifications

//WQ1 move alert:
const WQ1MoveAlert = new NotificationType();
WQ1MoveAlert.actionID = 2397;
WQ1MoveAlert.eventTypeID = null;
WQ1MoveAlert.name = 'Work Queue 1 Move Alert';

//WQ2 move alert:
const WQ2MoveAlert = new NotificationType();
WQ2MoveAlert.actionID = 2398;
WQ2MoveAlert.eventTypeID = null;
WQ2MoveAlert.name = 'Work Queue 2 Move Alert';

//WQ3 move alert:
const WQ3MoveAlert = new NotificationType();
WQ3MoveAlert.actionID = 2399;
WQ3MoveAlert.eventTypeID = null;
WQ3MoveAlert.name = 'Work Queue 3 Move Alert';

//export Notification Types
export const NOTIFICATION_TYPES = [
	AddModifySubmission,
	RequestApproval,
	TermRevokeRequest,
	RequestCompletion,
	WQ1MoveAlert,
	WQ2MoveAlert,
	WQ3MoveAlert,
];

export function GetNotificationTypes(WQSystems = []) {
	if (WQSystems.length > 1) {
		//assign event id's to notifications for multiple WQ notifications
		let updatedTypes = NOTIFICATION_TYPES.map(type => {
			switch (type.actionID) {
				case WQ1MoveAlert.actionID:
					type.eventTypeID = WQSystems.find(
						system => system.OrderBy === 1
					)?.AssignedID;
					return type;
				case WQ2MoveAlert.actionID:
					type.eventTypeID = WQSystems.find(
						system => system.OrderBy === 2
					)?.AssignedID;
					return type;
				case WQ3MoveAlert.actionID:
					type.eventTypeID = WQSystems.find(
						system => system.OrderBy === 3
					)?.AssignedID;
					return type;
				default:
					return type;
			}
		});

		return updatedTypes.filter(type => type.eventTypeID != null);
	} else {
		return NOTIFICATION_TYPES.filter(type => {
			return (
				type.actionID !== WQ1MoveAlert.actionID &&
				type.actionID !== WQ2MoveAlert.actionID &&
				type.actionID !== WQ3MoveAlert.actionID
			);
		});
	}
}
